import { useEffect, useState } from "react";

export function useCalculateValidPrice(item, isDiscountValid) {
  const itemPrice = Number(item?.price) || item?.defaultPrice;
  const timeLimitedDiscountAmount =
    item?.timeLimitedDiscountAmount ||
    item?.timeLimitedDiscount?.discountAmount ||
    0;

  // CALCULATE THE VALID PRICE
  const [validPrice, setValidPrice] = useState(itemPrice);

  useEffect(() => {
    if (isDiscountValid && item) {
      setValidPrice(itemPrice - timeLimitedDiscountAmount);
    } else {
      setValidPrice(itemPrice);
    }

    return () => setValidPrice(itemPrice);
  }, [isDiscountValid, item, itemPrice, timeLimitedDiscountAmount]);

  return validPrice;
}
